<!-- <footer class="footer-style-1" [ngStyle]="{'background-color': data?.footer?.bg_color }"> -->
<footer class="footer-style-1">
  <section id="footer" class="section-b-space darken-layout">
    @if (footerSection) {
    <div class="container">
      <div class="row footer-theme g-md-5 g-2">
        <div class="col-xl-3 col-lg-5 col-md-6 sub-title">
          <div>
            <app-footer-logo [footerConfig]="footerSection!.config"></app-footer-logo>
            <app-footer-contact [class]="'contact-list'" [contactConfig]="footerSection!.config"></app-footer-contact>
          </div>
        </div>
        @if (menuConfig && menuConfig.visible) {
        @for (item of menuConfig.values; track $index) {
        @if (item.visible) {
        <div class="col-xl-2 col-lg-3 col-md-4 col-md-6">
          @if (item.display_title) {
          <div class="sub-title">
            <div class="footer-title" [class.show]="active['menu_' + $index]" (click)="toggle('menu_' + $index)">
              <h4>{{ item.title }}</h4>
            </div>
            <div class="footer-content" [class.show]="active['menu_' + $index]">
              <!-- <app-footer-categories [categoryIds]="data?.footer?.footer_categories || []"></app-footer-categories><app-footer-categories [categoryIds]="data?.footer?.footer_categories || []"></app-footer-categories> -->
              <app-footer-links [navigation]="item.navigations || []"></app-footer-links>
              <!-- No Data -->
              <!-- <app-no-data [class]="'no-data-footer'" [text]="'no_category_found'"
                                                                                                                            *ngIf="!data?.footer?.footer_categories?.length"></app-no-data> -->
            </div>
          </div>
          }
        </div>
        }
        }
        }

        @if (socialConfig && socialConfig.visible) {
        <div class="col-xl-3 col-lg-4 col-md-6">
          <div class="sub-title">
            <div class="footer-title" [class.show]="active['social']" (click)="toggle('social')">
              <!-- <h4>{{footerSectionSocial.label}}</h4> -->
              <h4>{{ "follow_us" | translate }}</h4>
            </div>
            <div class="footer-content" [class.show]="active['social']">
              <div class="footer-social">
                <ul>
                  @for (social of socialConfig!.values; track $index) {
                  @if (social.visible) {
                  @switch (social.value) {
                  @case (SOCIAL_SHARE.FACEBOOK) {
                  <li>
                    <a href="" target="_blank">
                      <i class="ri-facebook-fill"></i>
                    </a>
                  </li>
                  }
                  @case (SOCIAL_SHARE.TWITTER) {
                  <li>
                    <a href="" target="_blank">
                      <i class="ri-twitter-fill"></i>
                    </a>
                  </li>
                  }
                  @case (SOCIAL_SHARE.TWITTER) {
                  <li>
                    <a href="" target="_blank">
                      <i class="ri-twitter-fill"></i>
                    </a>
                  </li>
                  }
                  @case (SOCIAL_SHARE.INSTAGRAM) {
                  <li>
                    <a href="" target="_blank">
                      <i class="ri-instagram-fill"></i>
                    </a>
                  </li>
                  }
                  @case (SOCIAL_SHARE.PINTEREST) {
                  <li>
                    <a href="" target="_blank">
                      <i class="ri-pinterest-fill"></i>
                    </a>
                  </li>
                  }
                  @case (SOCIAL_SHARE.SNAPCHAT) {
                  <li>
                    <a href="" target="_blank">
                      <i class="ri-snapchat-fill"></i>
                    </a>
                  </li>
                  }
                  @case (SOCIAL_SHARE.TIKTOK) {
                  <li>
                    <a href="" target="_blank">
                      <i class="ri-tiktok-fill"></i>
                    </a>
                  </li>
                  }
                  @case (SOCIAL_SHARE.WHATSAPP) {
                  <li>
                    <a href="" target="_blank">
                      <i class="ri-whatsapp-fill"></i>
                    </a>
                  </li>
                  }
                  }
                  }
                  }
                </ul>
              </div>
            </div>

            <!-- <app-footer-news-letter [newsLetterStyle]="'classic'">
                                                                          @if(data?.footer?.social_media_enable){
                                                                          <app-footer-social-links [data]="data"></app-footer-social-links>
                                                                          }
                                                                        </app-footer-news-letter> -->
          </div>
        </div>
        }
      </div>
    </div>
    }
  </section>
  @if (subFooterSection ) {
  <app-sub-footer [subFooterConfig]="subFooterSection!.config"></app-sub-footer>
  }
</footer>